<template>
  <label
    :class="[
      ns.b('button'),
      ns.bm('button', size),
      ns.is('disabled', isDisabled),
      ns.is('checked', isChecked),
      ns.is('focus', isFocused),
      ns.is('vertical', vertical),
    ]"
    data-test-name="checkbox-button"
    data-test-variant=""
    data-test-state=""
  >
    <input
      v-if="trueValue || falseValue"
      v-model="model"
      :class="ns.be('button', 'original')"
      type="checkbox"
      :name="name"
      :tabindex="tabindex"
      :disabled="isDisabled"
      :true-value="trueValue"
      :false-value="falseValue"
      @change="handleChange"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
    <input
      v-else
      v-model="model"
      :class="ns.be('button', 'original')"
      type="checkbox"
      :name="name"
      :tabindex="tabindex"
      :disabled="isDisabled"
      :value="value"
      @change="handleChange"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />

    <span v-if="$slots.default || label" :class="ns.be('button', 'inner')">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'
import { useNamespace } from '@bigin/hooks'
import { useCheckbox } from './composables'
import { checkboxEmits, checkboxProps } from './checkbox'

defineOptions({
  name: 'BCheckboxButton',
})

const props = defineProps(checkboxProps)
defineEmits(checkboxEmits)
const slots = useSlots()

const {
  isFocused,
  isChecked,
  isDisabled,
  size,
  model,
  vertical,
  handleChange,
} = useCheckbox(props, slots)
const ns = useNamespace('checkbox')
</script>
